import { SelectOptions } from '../types/selectOptions.types';

export const tipPercentages: SelectOptions[] = [
  { id: '10', value: '10%' },
  { id: '15', value: '15%' },
  { id: '18', value: '18%' },
];
